import { motion } from "framer-motion";
import { SERVICES } from "../data/content";

export const Services = () => {
  return (
    <section id="servicos" data-testid="services-section" className="bg-[#FAFAFA] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-16">
          <div>
            <p className="label-editorial text-clay mb-6">O que fazemos por si</p>
            <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-none">
              Serviços de <span className="italic text-clay">imagem</span>
            </h2>
          </div>
          <p className="max-w-sm text-black/50 font-light text-sm md:text-base">
            Saiba tudo sobre como cuidar da sua imagem e sentir-se único, do
            cabelo ao guarda-roupa, do pessoal ao empresarial.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-black/5 border border-black/5">
          {SERVICES.map((service, i) => (
            <motion.a
              key={service.id}
              href="#marcacoes"
              data-testid={`service-card-${service.id}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className={`group bg-white p-8 flex flex-col ${i === 0 ? "lg:row-span-2" : ""}`}
            >
              <div className={`img-hover-zoom mb-8 ${i === 0 ? "h-64 lg:h-[28rem]" : "h-56"}`}>
                <img
                  src={service.image}
                  alt={`${service.title}, serviço de consultoria de imagem INN.PACT em Leiria`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  decoding="async"
                />
              </div>
              <span className="label-editorial text-clay/60 mb-3">0{i + 1}</span>
              <h3 className="font-display text-2xl md:text-3xl tracking-tight group-hover:-translate-y-1 transition-transform duration-500">
                {service.title}
              </h3>
              <p className="mt-4 text-sm text-black/55 font-light leading-relaxed">{service.description}</p>
              <span className="mt-auto pt-6 label-editorial text-clay/70 group-hover:text-clay transition-colors duration-300">
                Agendar →
              </span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
};
